import { render, staticRenderFns } from "./FilterItemActiniaI.vue?vue&type=template&id=5d06bb89&scoped=true&"
import script from "./FilterItemActiniaI.vue?vue&type=script&lang=js&"
export * from "./FilterItemActiniaI.vue?vue&type=script&lang=js&"
import style0 from "./FilterItemActiniaI.vue?vue&type=style&index=0&id=5d06bb89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d06bb89",
  null
  
)

export default component.exports